import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	root: {
		minWidth: 0,
	},
	actions: {
		height: "56px",
		...shorthands.padding(
			tokens.spacingHorizontalL,
			"",
			tokens.spacingHorizontalL,
			tokens.spacingHorizontalL
		),
		marginLeft: "auto",
	},
	actionItem: {
		cursor: "pointer",
		backgroundColor: tokens.colorNeutralBackground1,
		...shorthands.padding("4px", 0),
		...shorthands.border("none"),
	},
	popoverSurface: {
		...shorthands.padding(0),
		zIndex: 100,
	},
	listContainer: {
		width: "300px",
		maxHeight: "620px",
	},
	listItem: {
		backgroundColor: tokens.colorNeutralBackground1,
		"&:not(:last-of-type)": {
			...shorthands.borderBottom("none"),
		},
	},
	listMainText: {
		fontSize: tokens.fontSizeBase300,
		fontWeight: 600,
		lineHeight: "20px",
	},
	listItemMedia: {
		backgroundColor: tokens.colorNeutralBackground5,
		"&>span": {
			backgroundColor: tokens.colorNeutralBackground6,
			color: tokens.colorNeutralForeground3,
		},
	},
	listItemStartMedia: {
		backgroundColor: "transparent",
	},
});
